export default __webpack_public_path__ + "static/media/uttarakhand_desktop.e2239157.jpg";